export interface SpaceToolConfig {
	title: string
	icon: string
	description: string
	entryAction: string
	target?: string
	order?: number
}

export interface ServiceConfig {
	layout?: () => Promise<unknown>
	actions: Record<string, () => Promise<unknown>>
	spaceTool?: SpaceToolConfig
}

export const services: Record<string, ServiceConfig> = {
	auto: {
		spaceTool: {
			title: 'Автоматизация',
			icon: 'auto',
			description: 'Places, сценарии и логика процессов',
			entryAction: 'places',
			target: 's',
			order: 15
		},
		actions: {
			'places': () => import('@/views/auto/AutoPlacesListView.vue'),
			'place': () => import('@/views/auto/AutoPlaceEditorView.vue')
		}
	},
	conn: {
		spaceTool: {
			title: 'Коннектор',
			icon: 'conn',
			description: 'Channels, endpoint-конфиг и история входящих/исходящих обменов',
			entryAction: 'channels',
			target: 's',
			order: 16
		},
		actions: {
			'channels': () => import('@/views/conn/ConnectorChannelsListView.vue'),
			'channel': () => import('@/views/conn/ConnectorChannelView.vue')
		}
	},
	comm: {
		spaceTool: {
			title: 'Переписка',
			icon: 'comm',
			description: 'История обменов и ручные отправки через подключенные модули',
			entryAction: 'conversations',
			target: 's',
			order: 17
		},
		actions: {
			'conversations': () => import('@/views/comm/CommConversationsView.vue'),
			'conversation': () => import('@/views/comm/CommConversationView.vue')
		}
	},
	events: {
		spaceTool: {
			title: 'Реакции',
			icon: 'events',
			description: 'Правила обработки событий и запуска операций',
			entryAction: 'reactions',
			target: 's',
			order: 18
		},
		actions: {
			'reactions': () => import('@/views/events/EventReactionsListView.vue'),
			'reaction': () => import('@/views/events/EventReactionEditorView.vue')
		}
	},
	fields: {
		spaceTool: {
			title: 'Поля',
			icon: 'fields',
			description: 'Дополнительные данные сущностей пространства и модулей',
			entryAction: 'definitions',
			target: 's',
			order: 19
		},
		actions: {
			'definitions': () => import('@/views/fields/FieldDefinitionsListView.vue'),
			'definition': () => import('@/views/fields/FieldDefinitionEditorView.vue'),
			'values': () => import('@/views/fields/FieldValuesView.vue'),
			...(import.meta.env.DEV || window.location.hostname.endsWith('.local')
				? { 'selector-test': () => import('@/dev/PlatformFieldsSelectorHarness.vue') }
				: {})
		}
	},
	parties: {
		spaceTool: {
			title: 'Участники',
			icon: 'comm',
			description: 'Контакты и внешние идентификаторы участников',
			entryAction: 'parties',
			target: 's',
			order: 19.5
		},
		actions: {
			'parties': () => import('@/views/parties/PartiesListView.vue'),
			'party': () => import('@/views/parties/PartyEditorView.vue')
		}
	},
	settings: {
		spaceTool: {
			title: 'Настройки',
			icon: 'settings',
			description: 'Глобальный каталог инструментов и внешних модулей',
			entryAction: 'catalog',
			target: 's',
			order: 30
		},
		actions: {
			'catalog': () => import('@/views/settings/SpaceCatalogView.vue')
		}
	},
	billing: {
		spaceTool: {
			title: 'Биллинг',
			icon: 'billing',
			description: 'Платежи, счета и история операций',
			entryAction: 'overview',
			target: 's',
			order: 20
		},
		actions: {
			'overview': () => import('@/views/billing/OverviewView.vue'),
			'payments': () => import('@/views/billing/PaymentsView.vue'),
			'history': () => import('@/views/billing/HistoryView.vue'),
			'invoices': () => import('@/views/billing/InvoicesView.vue')
		}
	}
}

export const registerService = (name: string, config: ServiceConfig) => {
	services[name] = config
}

